import styles from '../../assets/styles/Settings/Settings.module.scss';
import { MimaButton, MimaText, MimaToastUtil, Modal } from '../../components';
import React, { useState } from 'react';
import constant from '../../utils/constant';
import { BusinessController } from '../../controllers';

const FreePlanConfirmation = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);

	const downgrade = async () => {
		setLoading(true);
		const { status, errorMessage } =
			await BusinessController.donwgradeToFreePlan();

		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: 'Successful',
			});
			return closeModal();
		}

		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<Modal closeModal={closeModal}>
			<MimaText
				variant="subtitleBold"
				mb={7}
				color="var(--color-primary)"
				align="center">
				Downgrade To Free Plan
			</MimaText>
			<MimaText variant="subtitle" mb={4} align="center">
				Are you sure you want to downgrade to our free plan services with
				limited features?
			</MimaText>

			<div className={styles.beside}>
				<MimaButton
					title="Downgrade"
					variant="small"
					loading={loading}
					onClick={downgrade}
				/>
				<MimaButton
					title="Cancel"
					variant="small"
					onClick={closeModal}
					buttonColor="var(--color-dark-3)"
				/>
			</div>
		</Modal>
	);
};

export default FreePlanConfirmation;
